<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
    style="text-align: left">
      <el-form :model="dataForm" :rules="dataRule" ref="dataForm"
               label-width="150px">
               <el-form-item label="手机号码" prop="sjhm">
								<el-input clearable :disabled="dataForm.id" v-model="dataForm.sjhm" placeholder="请输入手机号码"></el-input>
							</el-form-item>
              <el-form-item label="部门" prop="bm" >
                <el-input clearable v-model="dataForm.bm" placeholder="请输入部门"></el-input>
              </el-form-item>
              <el-form-item label="岗点" prop="gd" >
                <el-input clearable v-model="dataForm.gd" placeholder="请输入岗点"></el-input>
              </el-form-item>
							<el-form-item label="使用人" prop="syr" >
                <el-input clearable v-model="dataForm.syr" placeholder="请输入使用人"></el-input>
              </el-form-item>
              <el-form-item label="责任人" prop="zrr" >
                <el-input clearable v-model="dataForm.zrr" placeholder="请输入责任人"></el-input>
              </el-form-item>
							<el-form-item label="职务" prop="zw">
								<el-input clearable v-model="dataForm.zw" placeholder="请输入职务"></el-input>
							</el-form-item>
							<el-form-item label="短号" prop="dh">
								<el-input clearable v-model="dataForm.dh" placeholder="请输入短号"></el-input>
							</el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
      </span>
    </el-dialog>
  </template>
  
  <script>
    export default {
  
      data () {
        const validateNumber = (rule, value, callback) => {
          if(value) {
            var patrn = /^\d+(\.\d+)?$/;
            if (!patrn.exec(value)) {
              callback(new Error('请填写数字'))
            } else {
              callback()
            }
          } else {
            if(rule.field === 'sjhm') {
              callback(new Error('请输入手机号码'))
            } else {
              callback()
            }
          }
        }
        return {
          visible: false,
          loading1:false,
          dataForm: {
            id: '',
            sjhm: '',
            bm: '',
            gd: '',
            syr: '',
            zrr: '',
            zw: '',
            dh: ''
          },
          dataRule: {
            sjhm: [
              {required: true, validator:validateNumber, trigger: 'blur'}
            ],
            bm: [
              {required: true, message: '请输入部门', trigger: 'blur'}
            ],
            gd: [
              {required: true, message: '请输入岗点', trigger: 'blur'}
            ],
            syr: [
              {required: true, message: '请输入使用人', trigger: 'blur'}
            ],
            zrr: [
              {required: true, message: '请输入责任人', trigger: 'blur'}
            ],
            dh:[
              {validator:validateNumber,trigger: 'blur'}
            ]
          }
        }
      },
      methods: {
        init (id) {
          this.dataForm.id = id
          this.visible = true
          this.$nextTick(() => {
            this.$refs['dataForm'].resetFields()
            if(this.dataForm.id) {
              this.$http({
                url: '/bjba/addressBook/info/'+this.dataForm.id,
                method: 'get'
              }).then(({data}) => {
                this.dataForm = data.data
              })
            }
          })
        },

        // 表单提交
        dataFormSubmit () {
          this.$refs['dataForm'].validate((valid) => {
            if (valid) {
                console.log("要提交的表单信息为：",this.dataForm)
                  this.$http({
                    url: `/bjba/addressBook/`+(this.dataForm.id?'update':'save'),
                    method: 'post',
                    data: this.dataForm
                  }).then(({data}) => {
                    if (data && data.code === 200) {
                      this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 1500
                      })
                      this.visible = false
                      this.$emit('refreshDataList')
                    } else if(data && data.code === 500) {
                      this.$message({
                        message: data.message,
                        type: 'error',
                        duration: 1500
                      })
                    }
                  })
            }
          })
        }
      }
    }

  </script>
  